<div class="testing-wrap">
  <div class="testing-header">
      <back-button></back-button>
  </div>
  <div class="testing-module-wrap">
      <div class="testing-module-header">
          <div class="testing-module-header-text-wrap" >
              @if(typeModule?.type === 'final'){
                <h1 class="testing-module-header__title">Итоговое тестирование</h1>
              }@else{
                <h1 class="testing-module-header__title">Вопросы для самопроверки</h1>
                <h3 class="testing-module-header__sub-title">Модуль №{{typeModule?.module}}. {{moduleTitle()}}</h3>
              }
          </div>
        <img  class="testing-module__image" src="assets/images/ui-kit-img/testing.svg"/>
      </div>
    <div class="testing-module-description-wrap">
        <ul>
          @if(typeModule?.type === 'final'){
            <li class="din-pro-text">Успешное прохождение итогового теста позволяет получить сертификат о прослушивании курса</li>
            <li class="din-pro-text">Для этого необходимо правильно ответить минимум на 13 вопросов из 17</li>
            <li class="din-pro-text">Количество попыток не ограничено</li>
          }@else{
            <li class="din-pro-text">{{ countQuestion() }} {{ Number(countQuestion()) | declensionPipe: ['вопрос', 'вопроса', 'вопросов'] }}, чтобы закрепить тему</li>
            <li class="din-pro-text">Количество попыток не ограничено</li>
          }
        </ul>
              </div>

        <button (click)="routeTest()" class="button active">Начать</button>
  </div>

</div>

